export const limitByUserRole = {
  ROLE_FREE_USER: { project: 1, form: 3 },
  ROLE_BASIC_USER: { project: 5, form: 10 },
  ROLE_PREMIUM_USER: { project: 10, form: 25 },
};


